/*
  Copyright 2018 Google LLC

  Use of this source code is governed by an MIT-style
  license that can be found in the LICENSE file or at
  https://opensource.org/licenses/MIT.
*/

import {initialize} from './initialize.mjs';
import './_version.mjs';


/**
 * @namespace workbox.googleAnalytics
 */

export {
  initialize,
};
